document.addEventListener("DOMContentLoaded", function () {
    const logoSlider = document.querySelector(".move-slider");
    const logos = document.querySelectorAll(".move");

    const totalWidth = Array.from(logos).reduce(
      (acc, logo) => acc + logo.offsetWidth,
      2170
    );

    logoSlider.style.width = totalWidth + "px";

    logos.forEach((logo) => {
      logoSlider.appendChild(logo.cloneNode(true));
    });

    let isHovered = false;
    let touchStartX;
    let startX;
    let currentTranslate = 0;

    function handleHover() {
      isHovered = !isHovered;
      logoSlider.style.animationPlayState = isHovered ? "paused" : "running";
    }

    function handleTouchStart(e) {
      isHovered = true;
      touchStartX = e.touches[0].clientX;
      startX = e.touches[0].clientX;
      logoSlider.style.animationPlayState = "paused";
    }

    function handleTouchMove(e) {
      if (!isHovered) return;
      const delta = e.touches[0].clientX - touchStartX;
      logoSlider.style.transform = `translateX(${currentTranslate + delta}px)`;
    }

    function handleTouchEnd() {
      isHovered = false;
      logoSlider.style.animationPlayState = "running";
      currentTranslate = parseFloat(
        getComputedStyle(logoSlider).transform.split(",")[4]
      );
    }

    function handleSwipe(e) {
      if (isHovered) return;
      const delta = e.clientX - startX;
      logoSlider.style.transform = `translateX(${currentTranslate + delta}px)`;
    }

    logoSlider.addEventListener("mouseover", handleHover);
    logoSlider.addEventListener("mouseout", handleHover);

    logoSlider.addEventListener("touchstart", handleTouchStart);
    logoSlider.addEventListener("touchmove", handleTouchMove);
    logoSlider.addEventListener("touchend", handleTouchEnd);

    logoSlider.addEventListener("mousedown", function (e) {
      if (isHovered) return;
      startX = e.clientX;
      currentTranslate = parseFloat(
        getComputedStyle(logoSlider).transform.split(",")[4]
      );

      document.addEventListener("mousemove", handleSwipe);
      document.addEventListener("mouseup", function () {
        document.removeEventListener("mousemove", handleSwipe);
      });
    });
  });